import { createAction } from "redux-act";

export const savePresentersInLookups = createAction<any>(
  "add presneters ref to look ups"
);
